import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { sandyConfig } from "./data";

export default function SandyPage() {
  return <OregonCityPageTemplate config={sandyConfig} />;
}